import { LEVELS_TO_UNLOCK_FEATURES, LAST_LEVEL_WITH_SMALL_PAUSE_ICON } from '~/lib/constants';
// ---- internal imports ----

import { hasMissionFailed, updateFailureTextWithValues } from './helpers';
import { getTurnNum } from '../turn/selectors';
import { turnSelectors } from '../selectors';
// ---- local imports ----


export function getFailedMissions(state) {
	const missions = getMissions(state);
	return missions.filter((mission) => hasMissionFailed(state, mission));

}

export function hasRestartGameOption(state) {
	return getLevelData(state, getLevelNumber(state) - 1).canRestartOnFailing ?? false;
}

export function getMaxLevelNum(state) {
	return state.level.levelList.length;
}

export function getLevelNumber(state) {
	return state.level.number;
}

export function shouldShowSmallPauseIcon(state) {
	const levelNumber = getLevelNumber(state);
	return levelNumber != null && levelNumber <= LAST_LEVEL_WITH_SMALL_PAUSE_ICON;
}

export function getMissions(state) {
	return state.level.missions;
}

export function getLevelData(state, id) {
	return state.level.levelList[id];
}

export function hasNewFeaturedUnlocked(state) {
	return state.level.featuresToUnlock.length > 0;
}

export function getNewFeaturedUnlocks(state) {
	return state.level.featuresToUnlock;
}

export function getStory(state) {
	return state.level.story;
}

export function shallAutomaticallySubmitFinancialStatement(state) {
	return getLevelNumber(state) <= LAST_LEVEL_TO_AUTOMATICALLY_FILL_FINANCIAL_STATEMENTS;
}

export function hasContinueOption(state) {
	return state.level.missions.some((mission) => mission.hasContinueOption);
}

export function hasFeatureUnlocked(state, feature) {
	const level = getLevelNumber(state);
	return level >= LEVELS_TO_UNLOCK_FEATURES[feature];
}

export function isInstantLevelUp(state) {
	const levelNumber = getLevelNumber(state);
	const levelData = getLevelData(state, levelNumber - 1);

	return levelData.instantLevelUp ?? false;
}

export function shouldSaveCompletionAfterNewTurn(state, levelNumber) {
	const levelData = getLevelData(state, levelNumber - 1);

	return levelData.shouldSaveCompletionAfterNewTurn;
}

export function getMissionFailedText(state) {
	const failedMissions = getFailedMissions(state);
	const failureTexts = updateFailureTextWithValues(state, failedMissions);
	return failureTexts;
}

export function shouldReplayLevel(state) {
	const failedMissions = getFailedMissions(state);

	return failedMissions.length > 0;
}

export function isFirstAttemptInLevel(state) {
	return state.level.isFirstAttemptInLevel;
}

export function isFirstCustomerPhaseInLevel(state) {
	const isCustomersPhase = turnSelectors.isCustomersPhase(state);

	if (!isCustomersPhase) {
		return false;
	}

	const turn = getTurnNum(state);
	const startTurn = getMissions(state)[0]?.startedInTurn ?? -1;

	return turn === startTurn;
}

export function isFirstTurnInLevel(state) {
	const isPreparationPhase = turnSelectors.isPreparationPhase(state);

	if (!isPreparationPhase) {
		return false;
	}

	const turn = getTurnNum(state);
	const startTurn = getMissions(state)[0]?.startedInTurn ?? -1;

	return turn === startTurn;
}

export function isFirstTurnInSpecificLevel(state, levelNumber) {
	const currentLevelNumber = getLevelNumber(state);
	return levelNumber === currentLevelNumber && isFirstTurnInLevel(state);
}
